import { Component, Input, OnChanges } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { AggregationDataset } from '../../../shared/interfaces/visualizations/aggregation-dataset.interface'

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})
export class IframeComponent implements OnChanges {
  @Input() dataset: AggregationDataset

  source: SafeResourceUrl

  constructor(public sanitizer: DomSanitizer) {}

  ngOnChanges() {
    this.source = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.dataset.data[0].uri
    )
  }
}
